(function() {
	const settings = {
		// Regular Options
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,

        // Responsive Options
        responsive: [{
            breakpoint: 1680,
            settings: {
                slidesToShow: 5,
                infinite: true
            }
        }, {
            breakpoint: 1024,
            settings: {
            	slidesToShow: 4
            }
        }, {

            breakpoint: 980,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 640,
            settings: {
            	slidesToShow: 2
            }
        }, {
            breakpoint: 580,
            // settings: {
            // 	slidesToShow: 1
            // }
            settings: "unslick" // destroys slick
        }]
	}

    const bannerSettings = {
        // Regular Options
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        swipeToSlide: true
    }


    const sl = $(".product-slides").slick(settings);
    const hsl = $(".hero__slides").slick(bannerSettings);


	$(window).on('resize', function() {
	   if( $(window).width() > 580 &&  !sl.hasClass('slick-initialized')) {
	        $(".product-slides").slick(settings);
	    }
	});
}());

// $(window).resize(function(e) {
// 	$frame.sly('reload');
// });